import Stack from '@mui/material/Stack';
import {GridCellParams} from '@mui/x-data-grid';
import ListItemText from '@mui/material/ListItemText';
import LinearProgress from '@mui/material/LinearProgress';

import {fCurrency} from 'src/utils/format-number';
import {fTime, fDate} from 'src/utils/format-time';

import Label from 'src/components/label';

// ----------------------------------------------------------------------

type ParamsProps = {
  params: GridCellParams;
  handlePublishChange?: (data: any) => void;
  onChange?: (data: any) => void;
};

export function RenderCellPrice({params}: ParamsProps) {
  return <>{fCurrency(params.row.price)}</>;
}

export function RenderCellPublish(Props: ParamsProps) {
  const {params, handlePublishChange,onChange} = Props;
  const publishChange = (value: string, id: number) => {
    const publishvalue = {id: id, value: value};
    console.log('publishChangesdfsdfsdf', publishvalue);
    if (handlePublishChange && typeof handlePublishChange === 'function') {
      handlePublishChange(publishvalue);
    }
  };
  return (
    <Label
      variant="soft"
      onChange={onChange}
      onClick={() => {
        console.log('params.row[params.field]', params);
        publishChange(params.row[params.field], Number(params.id));
      }}
      color={(params.row[params.field] === 'PUBLISHED' && 'info') || 'default'}>
      {params.row[params.field]}
    </Label>
  );
}

export function RenderCellCreatedAt({params}: ParamsProps) {
  return (
    <ListItemText
      primary={fDate(params.row[params.field])}
      secondary={fTime(params.row[params.field])}
      primaryTypographyProps={{typography: 'body2', noWrap: true}}
      secondaryTypographyProps={{
        mt: 0.5,
        component: 'span',
        typography: 'caption'
      }}
    />
  );
}

export function RenderCellStock({params}: ParamsProps) {
  return (
    <Stack sx={{typography: 'caption', color: 'text.secondary'}}>
      <LinearProgress
        value={(params.row.available * 100) / params.row.quantity}
        variant="determinate"
        color={
          (params.row.inventoryType === 'out of stock' && 'error') ||
          (params.row.inventoryType === 'low stock' && 'warning') ||
          'success'
        }
        sx={{mb: 1, height: 6, maxWidth: 80}}
      />
      {!!params.row.available && params.row.available}{' '}
      {params.row.inventoryType}
    </Stack>
  );
}

export function RenderCellProduct({params}: ParamsProps) {
  const valuesd = params.row[params.field];
  return (
    <Stack direction="row" alignItems="center" sx={{py: 2, width: 1}}>
      {valuesd}
    </Stack>
  );
}
